import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { applicationInfo } from './request';
import { customerResource } from '../../system/customerManage/request';
export default {
  props: {
    currentRow: [Object, null],
    dialogVisible: Boolean,
    tableData: Array,
    seeInfo: Boolean
  },
  data() {
    return {
      imageUrl: '',
      type: [],
      from: {
        name: '',
        appid: '',
        introduce: '',
        type: undefined,
        icon: '',
        customerId: undefined
      },
      customerList: [],
      defaultCheckedList: [],
      loading: false
    };
  },
  computed: {
    roleList() {
      return this.tableData.map(item => item.role);
    }
  },
  mounted() {
    applicationInfo({
      applicationId: this.currentRow.id
    }).then(res => {
      console.log(res);
      this.from = res;
      if (this.from.icon) {
        this.imageUrl = this.from.icon;
      }
    });
    // this.from = { ...this.currentRow } || {};
    customerResource({
      isLicense: 1
    }).then(res => {
      this.customerList = res;
    });
    console.log(this.from);
  },
  methods: {}
};